export default "__VITE_ASSET__uLwP9Yug__"